import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccionesDialog } from '@models/base/identificadores.model';
import { CasoUsoDto } from '@models/seguridad/casosUso/casoUsoDto.model';
import { CreatePermisoRequest } from '@models/seguridad/permisos/createPermisoRequest.model';
import { PermisoDto } from '@models/seguridad/permisos/permisoDto.model';
import { UpdatePermisoRequest } from '@models/seguridad/permisos/updatePermisoRequest.motel';
import { RolDto } from '@models/seguridad/roles/rolDto.model';
import { CasosUsoService } from '@services/seguridad/casos-uso/casos-uso.service';
import { PermisosService } from '@services/seguridad/permisos/permisos.service';
import { RolesService } from '@services/seguridad/roles/roles.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { DialogUpdatePermisoComponent } from '../actualizar-permiso/dialog-update-permiso/dialog-update-permiso.component';

@Component({
  selector: 'app-crear-permiso',
  templateUrl: './crear-permiso.component.html',
  styleUrls: ['./crear-permiso.component.css']
})
export class CrearPermisoComponent implements OnInit {

  formBuilder = new FormBuilder;
  form: any;
  permisoDto!:PermisoDto;
  casosUso!:CasoUsoDto[]
  roles!:RolDto[]
  casoUsoDto!:CasoUsoDto
  get f() { return this.form.controls; }

  constructor(
    public dialogRef: MatDialogRef<DialogUpdatePermisoComponent>,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private casosUsoService: CasosUsoService,
    private rolesService: RolesService,
    private permisosService: PermisosService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any

  ) {

    this.form = this.formBuilder.group({
      Descripcion: ["", Validators.compose([Validators.required,])],
      Token: ["", Validators.compose([Validators.required,])],
      CasoUso: ["", Validators.compose([Validators.required])],
      Rol: ["", Validators.compose([Validators.required])],
    })
  }

  ngOnInit(): void {
    this.getAllRol()
    this.getAllCasosUso()
  }

  getAllRol() {
    this.spinner.show("spBusquedaRoles")
    this.rolesService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaRoles")
          this.roles = data.sort((a, b) => a.descripcion.toString().toUpperCase().localeCompare(b.descripcion.toString().toUpperCase()))
        },
        error => {
          this.spinner.hide("spBusquedaRoles")
          this.snackBar.showError(error, "Error");
        }
      )
  }

  getAllCasosUso() {
    this.spinner.show("spBusquedaCasosUso")
    this.casosUsoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaCasosUso")
          this.casosUso = data.sort((a, b) => a.path.toString().toUpperCase().localeCompare(b.path.toString().toUpperCase()))
        },
        error => {
          this.spinner.hide("spBusquedaCasosUso")
          this.snackBar.showError(error, "Error");
        }
      )
  }


  doAction() {
    let createPermisoRequest: CreatePermisoRequest = new CreatePermisoRequest
    createPermisoRequest.descripcion = this.form.controls["Descripcion"].value
    createPermisoRequest.id_CasoUso = this.form.controls["CasoUso"].value
    createPermisoRequest.token = this.form.controls["Token"].value
    createPermisoRequest.id_Rol = this.form.controls["Rol"].value
    this.create(createPermisoRequest)
  }

  closeDialog() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }

  create(createPermisoRequest: CreatePermisoRequest) {
    this.spinner.show("spCrearPermiso")
    this.permisosService.create(createPermisoRequest)
      .subscribe(
        data => {
          this.spinner.hide("spCrearPermiso")
          this.snackBar.showSuccess("Registro agregado correctamente.", "Exito");
          this.dialogRef.close({ event: AccionesDialog.Modificar });
        },
        error => {
          this.spinner.hide("spCrearPermiso")
          this.snackBar.showError(error, "Error");
        }
      )
  }


  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }

}

